<div class='item' *ngFor='let item of visible_items' (click)='select(item); $event.stopPropagation()'
      [class.main]='item.kind === "main"'
      [class.sub]='item.kind === "sub"'
      [class.checked]='item.checked'
      [class.last]='item.last'
      [style.text-align]='textAlign'>
      <input type='checkbox' [checked]='item.checked' [tabindex]="active? 0: -1"/>
      <span [innerHTML]='item.value'></span>
</div>